module.exports = __webpack_public_path__ + "f3088cccacc2d77d746eb60758012ae1.jpg";